<template>
  <b-row>
    <b-col
      cols="5">
      <ContractSummary
        class="mt-2"
        :contract="contract"
        :contractCategories="contractCategories">
      </ContractSummary>
    </b-col>
    <b-col
      cols="7">
      <contract-information-form
        ref="contractInformationForm"
        :contractCategories="contractCategories">
      </contract-information-form>
    </b-col>
  </b-row>
</template>
<script>
  import ContractInformationForm from '@/components/contracts/ContractInformationForm'
  import ContractSummary from '@/components/contracts/ContractSummary'
  export default {
    name: 'ContractInformationDetails',
    components: {
      ContractInformationForm,
      ContractSummary
    },
    computed: {
      contract () {
        return this.$store.getters.currentContract
      },
      contractCategories () {
        return this.$store.getters.contractCategories.map(category => {
          return {
            value: category,
            text: this.$t('enums.contractCategories.' + category)
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/contracts/ContractInformationDetails.vue